import { Component, Input } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { ValidationHeaderComponent } from '../validation-header/validation-header.component';
import { ValidatePrescriberMatchFormComponent } from '../validate-prescriber-match-form/validate-prescriber-match-form.component';

@Component({
    selector: 'app-validate-prescriber-match',
    templateUrl: './validate-prescriber-match.component.html',
    styleUrls: ['./validate-prescriber-match.component.scss'],
    imports: [ValidationHeaderComponent, ValidatePrescriberMatchFormComponent]
})
export class ValidatePrescriberMatchComponent {
  collapsed = false;

  @Input() patientAttachment: PatientAttachment;

  constructor() {}


  onCollapseChange(collapsed) {
    this.collapsed = collapsed;
  }

  collapse() {
    this.collapsed = true;
  }

  expand() {
    this.collapsed = false;
  }
}
